import { render, staticRenderFns } from "./number-range.vue?vue&type=template&id=43cb43b2&scoped=true"
import script from "./number-range.vue?vue&type=script&lang=js"
export * from "./number-range.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cb43b2",
  null
  
)

export default component.exports